// This method builds map of parent picklist value to a list of dependent picklist values.
const buildPicklistDependency = ((parentOptions, childOptions) => {
    const parents = (parentOptions || []).filter(p => p && p.active);
    const children = (childOptions || []).filter(c => c && c.active);

    const parentCount = parents.length;
    const map = Object.create(null);
    for (const p of parents) map[p.value] = [];

    // --- base64 -> bytes (browser + Node) ---
    function b64ToBytes(b64 = "") {
        if (!b64) return new Uint8Array(0);
        if (typeof atob === "function") {
        const bin = atob(b64);
        const out = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
        return out;
        }
        // Node
        return Uint8Array.from(Buffer.from(b64, "base64"));
    }

    // --- test MSB-first bit ---
    function isBitSet(validForB64, bitIndex) {
        const bytes = b64ToBytes(validForB64);
        const bytePos = Math.floor(bitIndex / 8);
        if (bytePos >= bytes.length) return false;
        const bitPos = 7 - (bitIndex % 8);
        return (bytes[bytePos] & (1 << bitPos)) !== 0;
    }

    // For each child, append to every parent whose index bit is set.
    for (const child of children) {
        for (let i = 0; i < parentCount; i++) {
        if (isBitSet(child.validFor, i)) {
            const parentValue = parents[i].value;
            map[parentValue].push({ label: child.label, value: child.value });
        }
        }
    }

    return map;
})

export default buildPicklistDependency